"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var AuthenticationMethods;
(function (AuthenticationMethods) {
    AuthenticationMethods["Local"] = "local";
    AuthenticationMethods["Saml"] = "saml";
    AuthenticationMethods["OpenID"] = "openid";
    AuthenticationMethods["Jwt"] = "jwt";
    AuthenticationMethods["ApiKey"] = "apikey";
    AuthenticationMethods["ThirdParty"] = "thirdparty";
})(AuthenticationMethods = exports.AuthenticationMethods || (exports.AuthenticationMethods = {}));
//# sourceMappingURL=authentication-methods.js.map